import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientService } from '../api/api-client.service';
import { API_ENDPOINTS } from '../api/endpoints';
import {
  AuthMeResponse,
  ChangePasswordRequest,
  CompleteRegistrationRequest,
  CompleteRegistrationResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  RegisterCompanyStartRequest,
  RegisterCompanyStartResponse,
  VerifyRegistrationEmailRequest,
  VerifyRegistrationEmailResponse,
  LogoutResponse,
  ResetPasswordRequest,
  ValidateResetPasswordTokenRequest,
  ValidateResetPasswordTokenResponse,
  TokenResponse
} from './auth.models';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private readonly api: ApiClientService) {}

  login(payload: LoginRequest): Observable<TokenResponse> {
    return this.api.post<TokenResponse, LoginRequest>(API_ENDPOINTS.auth.login, payload);
  }

  logout(): Observable<LogoutResponse> {
    return this.api.post<LogoutResponse, Record<string, never>>(API_ENDPOINTS.auth.logout, {});
  }

  refresh(): Observable<TokenResponse> {
    return this.api.post<TokenResponse, Record<string, never>>(API_ENDPOINTS.auth.refresh, {});
  }

  me(): Observable<AuthMeResponse> {
    return this.api.get<AuthMeResponse>(API_ENDPOINTS.auth.me);
  }

  forgotPassword(payload: ForgotPasswordRequest): Observable<ForgotPasswordResponse> {
    return this.api.post<ForgotPasswordResponse, ForgotPasswordRequest>(
      API_ENDPOINTS.auth.forgotPassword,
      payload
    );
  }

  registerCompanyStart(
    payload: RegisterCompanyStartRequest
  ): Observable<RegisterCompanyStartResponse> {
    return this.api.post<RegisterCompanyStartResponse, RegisterCompanyStartRequest>(
      API_ENDPOINTS.auth.registerCompany,
      payload
    );
  }

  verifyRegistrationEmail(
    payload: VerifyRegistrationEmailRequest
  ): Observable<VerifyRegistrationEmailResponse> {
    return this.api.post<VerifyRegistrationEmailResponse, VerifyRegistrationEmailRequest>(
      API_ENDPOINTS.auth.verifyEmail,
      payload
    );
  }

  completeRegistration(
    payload: CompleteRegistrationRequest
  ): Observable<CompleteRegistrationResponse> {
    return this.api.post<CompleteRegistrationResponse, CompleteRegistrationRequest>(
      API_ENDPOINTS.auth.completeRegistration,
      payload
    );
  }

  resetPassword(payload: ResetPasswordRequest): Observable<LogoutResponse> {
    return this.api.post<LogoutResponse, ResetPasswordRequest>(
      API_ENDPOINTS.auth.resetPassword,
      payload
    );
  }

  validateResetPasswordToken(
    payload: ValidateResetPasswordTokenRequest
  ): Observable<ValidateResetPasswordTokenResponse> {
    return this.api.post<ValidateResetPasswordTokenResponse, ValidateResetPasswordTokenRequest>(
      API_ENDPOINTS.auth.validateResetPassword,
      payload
    );
  }

  changePassword(payload: ChangePasswordRequest): Observable<LogoutResponse> {
    return this.api.post<LogoutResponse, ChangePasswordRequest>(
      API_ENDPOINTS.auth.changePassword,
      payload
    );
  }
}
